var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4,4.682l2.85,2.839c0.403,0.402 0.404,1.055 0.002,1.458l-0.002,0.003l-16.512,16.449l-4.312,-4.295l16.518,-16.454c0.402,-0.401 1.053,-0.401 1.456,0Zm-19.76,18.233l4.312,4.295l-4.719,1.237c-0.33,0.086 -0.668,-0.111 -0.755,-0.442c-0.026,-0.099 -0.027,-0.203 -0.003,-0.303l1.165,-4.787Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e78844df36e1d9edcdf22d2edfb127f4.svg";
export { ForwardRef as ReactComponent };